"use strict";
import React from "react";
import FormsyFields from "./formsyFields";
import StyledCheckbox from "./styledCheckbox";
import Searchbox from "./searchbox";
import codePicker from "./codePicker";

const initComponent = (flex = window.flex) => {

    const CodePicker = codePicker(flex);

    class FormSection extends React.Component {
        state = {};

        selectItem = (item) => {
            if (item) this.setState({ selected: item });
            else this.setState({ selected: false });
        };

        render() {
            var section = this.props.section;
            const state = this.state || {};

            var controls = !section.controls ? false
                : section.controls.map((control, index) => {
                    return (<SectionControl key={index} control={control}></SectionControl>)
                });

            var collapsable = section.collapsable;

            const openContainer = collapsable && (!state.selected || state.selected.title != section.title) ? false :
                <div className="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                    <div className="panel-body form-group">
                        {controls}
                    </div>
                </div>;

            var panelClasses = openContainer ? "panel panel-default panel-open" : "panel panel-default panel-closed";

            if (!collapsable) {
                panelClasses += " nonCollapsable";
            }

            return (
                <div className={panelClasses} key={section.title}>
                    <div className="panel-heading" role="tab">
                        <a role="button" onClick={this.selectItem.bind(this, openContainer ? false : (collapsable ? section : section))}>
                            <span className="panel-title">
                                <span>
                                    {section.title}
                                </span>
                            </span>
                        </a>
                    </div>
                    {openContainer}
                </div>
            );
        }
    }

    class SectionControl extends React.Component {
        state = {};

        selectItem = (item) => {

            if (item) this.setState({ selected: item });
            else this.setState({ selected: false });
        };

        render() {
            const control = this.props.control;
            const options = control.options;
            const formProps = { layout: "vertical" };
            var element = null;
            const wrapperClass = control.wrapperClass || "col-md-12";
            const sequenceable = control.sequenceable || false;
            const childControls = !control.controls ? false
                : control.controls.map((control, index) => {
                    return (<SectionControl key={index} control={control}></SectionControl>)
                });
            if (!control.hidden) {
                if (control.type === 'Fieldset') {
                    element =
                        <fieldset>
                            <legend>{control.title}</legend>
                            {childControls}
                        </fieldset>;
                }

                if (control.type === 'CheckBox') {
                    element =
                        <div title={control.helpText} className="checkbox-group">
                            <StyledCheckbox disabled={control.disabled} {...formProps} id={control.id} label={control.title} name={control.id} defaultChecked={control.value} value={control.value}></StyledCheckbox>
                        </div>;

            }
            else if (control.type === "TextBox") {
                element =
                    <div title={control.helpText}>
                        <FormsyFields.Input disabled={control.disabled} {...formProps} validations={control.regexp || false} required={control.isRequired || false} validationError="Invalid" id={control.id} label={control.title} name={control.id} value={control.value} type="text" />
                    </div>;
            }
            else if (control.type === "MultiSelect") {
                element =
                    <div title={control.helpText}>
                        <CodePicker enableSequence={sequenceable}   {...formProps} required={control.isRequired || false} name={control.id} id={control.id} label={control.title} codes={options} value={control.value}></CodePicker>
                    </div>;
                }
            else if (control.type === "SingleSelect") {
                    element =
                        <div title={control.helpText}>
                        <CodePicker enableSequence={sequenceable}   {...formProps} required={control.isRequired || false} name={control.id} id={control.id} label={control.title} codes={options} value={control.value} single={true}></CodePicker>
                        </div>;
                }
            else if (control.type === "DropDown") {
                element =
                    <div title={control.helpText}>
                        <FormsyFields.Select disabled={control.disabled} {...formProps} onChange={control.eventHandler || this.selectItem} required={control.isRequired || false} id={control.id} name={control.id} label={control.title} options={options} value={control.value}></FormsyFields.Select>
                    </div>;
            }
            else if (control.type === "Searchbox") {
                element =
                    <div title={control.helpText}>
                        <Searchbox id={control.id} name={control.id} title={control.title} onChangeEventHandler={control.eventHandler} />
                    </div>;
            }
            else if (control.type === "Integer") {
                element =
                    <div title={control.helpText}>
                        <FormsyFields.Input disabled={control.disabled} {...formProps} validations="isInt" required={control.isRequired || false} validationError="Invalid" id={control.id} label={control.title} name={control.id} value={control.value} type="number" />
                    </div>
            }
        }

            return !control.hidden ? (<div className={"dynamic-form-control " + wrapperClass}>{element}</div>) : false;
        }
    }

    class DynamicForm extends React.Component {
        state = {};

        render() {
            var panels = !this.props.panels
                ? false
                : this.props.panels.map((panel, index) => {
                    if (!panel || panel.hidden) {
                        return false;
                    } else
                        return (<FormSection key={index} section={panel}></FormSection>);
                });
            var busyKey = this.props.busyKey;
            var showButton = this.props.showButton === undefined ? true : this.props.showButton;
            var formActions = !showButton ? false :
                (<div className="form-actions">
                    <button type="submit" className="btn btn-active ladda-button" disabled={flex.isBusy(busyKey)}>Save</button>
                </div>
                );
            return (
                <div>
                    <div>
                        {panels}
                    </div>
                    {formActions}
                </div>
            );

        }
    }

    return DynamicForm;
};

module.exports = initComponent;